var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-item"},[_c('div',{staticClass:"top"},[_vm._t("icon"),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])],2),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }